"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceResponseDefault = /** @class */ (function () {
    function ServiceResponseDefault() {
    }
    /**
     * @inheritDoc
     * @public
     * @override
     */
    ServiceResponseDefault.prototype.getMeta = function () {
        return this._meta;
    };
    /**
     * Set the meta of a response.
     * @param {Meta} meta - The meta of a response.
     * @public
     */
    ServiceResponseDefault.prototype.setMeta = function (meta) {
        this._meta = meta;
    };
    /**
     * @inheritDoc
     * @public
     * @override
     */
    ServiceResponseDefault.prototype.getData = function () {
        return this._data;
    };
    /**
     * Set the data of a response.
     * @param {T} data - The data of a response.
     * @public
     */
    ServiceResponseDefault.prototype.setData = function (data) {
        this._data = data;
    };
    return ServiceResponseDefault;
}());
exports.ServiceResponseDefault = ServiceResponseDefault;
//# sourceMappingURL=service-response-default.model.js.map